import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import CategoryIcon from "@mui/icons-material/Category";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import GroupIcon from "@mui/icons-material/Group";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { Navigation } from "@toolpad/core";

export const NAVIGATION: Navigation = [
  {
    kind: "header",
    title: "Main Menu",
  },
  {
    segment: "admin/dashboard",
    title: "Dashboard",
    icon: <DashboardIcon />,
  },
  {
    segment: "admin/orders",
    title: "Orders",
    icon: <ShoppingCartIcon />,
  },
  {
    segment: "admin/products",
    title: "Products",
    icon: <ProductionQuantityLimitsIcon />,
  },
  {
    segment: "admin/category",
    title: "Category",
    icon: <CategoryIcon />,
  },
  {
    segment: "admin/reports",
    title: "Reports",
    icon: <BarChartIcon />,
    children: [
      {
        segment: "sales",
        title: "Sales",
        icon: <DescriptionIcon />,
      },
      {
        segment: "traffic",
        title: "Traffic",
        icon: <DescriptionIcon />,
      },
    ],
  },
  {
    segment: "admin/shipping",
    title: "Shipping",
    icon: <ShoppingCartIcon />,
  },
  {
    segment: "admin/users",
    title: "Users",
    icon: <GroupIcon />,
  },
  {
    kind: "header",
    title: "Settings",
  },
  {
    segment: "admin/profile",
    title: "Profile",
    icon: <PersonIcon />,
  },
  {
    segment: "admin/preferences",
    title: "Preferences",
    icon: <ManageAccountsIcon />,
  },
];

export const NAVIGATION_USER: Navigation = [
  {
    kind: "header",
    title: "Main Menu",
  },
  {
    segment: "user/dashboard",
    title: "Dashboard",
    icon: <DashboardIcon />,
  },
  {
    segment: "user/orders",
    title: "Orders",
    icon: <ListAltIcon />,
  },
  {
    segment: "user/shipping",
    title: "Shipping",
    icon: <ShoppingCartIcon />,
  },
];
